// src/DateFormat.ts
var DateFormat = /* @__PURE__ */ ((DateFormat2) => {
  DateFormat2["TIME_SHORT"] = "TIME_SHORT";
  DateFormat2["TIME_LONG"] = "TIME_LONG";
  DateFormat2["DATE_SHORT"] = "DATE_SHORT";
  DateFormat2["DATE_SHORT_WEEKDAY"] = "DATE_SHORT_WEEKDAY";
  DateFormat2["DATE_MEDIUM"] = "DATE_MEDIUM";
  DateFormat2["DATE_LONG"] = "DATE_LONG";
  DateFormat2["DATE_NUMERIC"] = "DATE_NUMERIC";
  DateFormat2["DATE_PICKER"] = "DATE_PICKER";
  DateFormat2["DATETIME_MEDIUM"] = "DATETIME_MEDIUM";
  DateFormat2["MONTH_YEAR_SHORT"] = "MONTH_YEAR_SHORT";
  DateFormat2["MONTH_YEAR_LONG"] = "MONTH_YEAR_LONG";
  DateFormat2["RELATIVE_DAY"] = "RELATIVE_DAY";
  DateFormat2["RELATIVE_SHORT"] = "RELATIVE_SHORT";
  DateFormat2["RELATIVE_LONG"] = "RELATIVE_LONG";
  DateFormat2["RELATIVE_SMART"] = "RELATIVE_SMART";
  return DateFormat2;
})(DateFormat || {});

export {
  DateFormat
};
